// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"a1e6a00d","488":"62f84c45","787":"48eda048"}[chunkId] + ".chunk.js";
};